import React from "react";
import "./AppChip.css";

export default function AppChip({
  label,
  selected = false,
  onClick,
  icon: Icon,
  type = "button",
}) {
  return (
    <button
      type={type}
      className={`app-chip${selected ? " app-chip--selected" : ""}`}
      onClick={onClick}
      aria-pressed={selected}
    >
      {Icon ? <Icon className="app-chip__icon" aria-hidden /> : null}
      <span>{label}</span>
    </button>
  );
}
